var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"file","id":"avatar-upload"}}),_c('button',{on:{"click":_vm.upda}},[_vm._v("上传")])])}
var staticRenderFns = []

export { render, staticRenderFns }